import { Component, OnInit } from '@angular/core';
import { UsuarioRoles } from '../../../models/usuarioRoles.model';
import { UsuarioRolesLast } from '../../../models/usuarioRolesLast.model';
import { FuncionalidadRolesFull } from '../../../models/funcionalidadRolesFull.model';
import { FuncionalidadesService } from 'src/app/services/funcionalidades.service';
import { UsuariosService } from '../../../services/usuarios.service';
import { UsuarioRolesService } from '../../../services/usuario-roles.service';
import { FuncionalidadRolesService } from '../../../services/funcionalidad-roles.service';
import Swal, { SweetAlertResult } from 'sweetalert2';
import * as $ from 'jquery';

@Component({
  selector: 'app-asig-rol-usu',
  templateUrl: './asig-rol-usu.component.html',
  styleUrls: ['./asig-rol-usu.component.css']
})
export class AsigRolUsuComponent implements OnInit {

  titulo = 'Asignación de usuarios a roles en una misma funcionalidad';
  informacionIncompleta = 'Se debe seleccionar al menos un usuario y un rol de alguna funcionalidad';
  confirmacionAccion = 'Los roles y funcionalidades seleccionadas serán asignados a los usuarios seleccionados';
  errorAsignacion = 'Las asignaciones seleccionadas no pudieron realizarse';
  errorModificacion = 'La acción solicitada no se pudo completar';
  errorMasDeUnRol = 'No se puede asignar más de un rol a un mismo tramite, ¿Desea modificar el anterior rol ' +
                    'al nuevo rol seleccionado?';
  errorModificarUltAsig = 'Este usuario ya tiene un rol asignado al tramite seleccionado';
  modelo1 = 0;
  m_usu = 0;
  m_func = 0;
  m_rol = 0;
  contador = 0;
  numero = null;
  estado = false;
  cambio2 = false;
  cadena: string[] = [];
  list_roles_origen: any = [];
  list_roles_destino: any = [];
  list_roles_asig: FuncionalidadRolesFull[] = [];
  indiceRolOrigen: any;
  indiceRolDestino: any;
  rolOrigen: any | undefined;
  rolDestino: any | undefined;
  objeto: FuncionalidadRolesFull | undefined;
  usuarioRoles: UsuarioRoles | undefined;
  rol_func_final: FuncionalidadRolesFull[] = [];
  funcionalidades: any = [];
  usuarios: any = [];
  usuariosRoles: UsuarioRoles[] = [];
  ult_asig: UsuarioRolesLast[] = [];
  usuarioRol: UsuarioRoles | undefined;
  list_usu_n: number[] = [];
  listaUsuario:string[]=[]
  respuesta:any
  paginaUsuarios = 1;
  paginaAsignacion = 1
  cadenaUsuario:string[]=[]
  respuestaUsuarios:any=[]
  idAplicacion:string | undefined
  usuarioAplicativoRol:any

  tamanoPagina = 10
  paginaAcciones = 1;

  acciones:any=[]
  constructor(private funcionalidadRolesService: FuncionalidadRolesService,
              private funcionalidadesService: FuncionalidadesService,
              private usuariosService: UsuariosService,
              private usuarioRolesService: UsuarioRolesService)
  { }

  ngOnInit(): void {
    this.listaUsuario = []
    this.cargarFuncionalidades();
    this.cargarUsuarios();
    this.cargarAcciones()

    $("#cancel").on("click", function() {
      $("#caja").val('');
    });
  }
  getPageArray(): number[] {
    const pages = [];
    for (let i = 1; i <= 33; i++) {
      pages.push(i);
    }
    return pages;
  }

  cargarFuncionalidades(): void{
    this.funcionalidadesService.traerFuncionalidades()
    .subscribe(resp => {
      this.respuesta = resp
      this.funcionalidades = this.respuesta.data;
    });
  }

  cargarUsuarios(): void{
    this.usuariosService.traerUsuarios()
    .subscribe(resp => {
      this.respuesta = resp
      this.respuestaUsuarios = this.respuesta.data
      this.quitarDuplicados()
    });
  }

  quitarDuplicados(){
    let usuario:any
    this.cadenaUsuario =[]
    this.usuarios = []
    this.respuestaUsuarios.forEach((data: {
      idUsuario: string;
      nombreUsuario:string;
      email:string;
      perfil:string;
      area:string
    }) => {
    usuario={
      idUsuario:'',
      nombreUsuario:'',
      email:'',
      perfil:'',
      area:''
    }
    usuario.idUsuario = data.idUsuario
    usuario.nombreUsuario = data.nombreUsuario
    usuario.email=data.email
    usuario.perfil = data.perfil
    usuario.area = data.area
    if (!this.cadenaUsuario.includes(data.idUsuario)) {
      this.usuarios.push(usuario);
      this.cadenaUsuario.push(data.idUsuario);
    }
   });
  }


  ultimasAsignaciones(): void{
    this.usuarioRolesService.traerUltimasAsignaciones()
    .subscribe(resp => {
      this.ult_asig = resp;
    });
  }

  func_seleccion(e: any, x: number): void{

    this.idAplicacion = e.target[e.target.selectedIndex].value
    this.funcionalidadRolesService.traerFuncionalidadRolesById(e.target[e.target.selectedIndex].value)
    .subscribe(resp => {
      this.respuesta = resp
      if (x == 1) {
        this.list_roles_origen = this.respuesta.data[0].listaRoles;
      } else {
        this.list_roles_asig = this.respuesta.data[0].listaRoles;
      }
    });
  }

  seleccionRolOrigen(e: any, i:number): void{
    this.rolOrigen = this.list_roles_origen[i];
    this.indiceRolOrigen = this.list_roles_origen[i].idRol;
  }

  seleccionRolDestino(e: any, i:number): void{
    this.rolDestino = this.list_roles_destino[i];
    this.indiceRolDestino = this.list_roles_destino[i].idRol;
  }

  agregarRol(): void{
    if (this.rolOrigen != undefined) {
      if (!this.cadena.includes(this.rolOrigen.idRol)) {
        this.list_roles_destino.push(this.rolOrigen);
        this.cadena.push(this.rolOrigen.idRol);
      }
    }
  }

  quitarRol(): void{
    if (this.rolDestino != undefined) {
      this.list_roles_destino.splice(this.indiceRolDestino,1);
      this.cadena.splice(this.indiceRolDestino,1);
      this.indiceRolDestino = 0;
      this.rolDestino = undefined;
    }
  }

  buscar(texto: string): void{
    this.usuariosService.traerUsuario(texto)
    .subscribe(resp => {
      this.respuesta = resp
      this.respuestaUsuarios = this.respuesta.data
      this.quitarDuplicados()
    });
  }

  borrar(): void{
    this.cargarUsuarios();
  }

  todos(e: any): void{
    this.listaUsuario = [];
    this.usuarios.forEach((x: { inicio: any; idUsuario: string; }) => {
      x.inicio = e.target.checked
      if (e.target.checked) {
        this.listaUsuario.push(x.idUsuario)
      }
    });
  }


  cancelar(): void{
    this.modelo1 = 0;
    this.listaUsuario = [];
    this.indiceRolOrigen = '';
    this.indiceRolDestino = '';
    this.rolOrigen = undefined;
    this.rolDestino = undefined;
    this.cadena = [];
    this.cadenaUsuario=[]
    this.list_roles_origen = [];
    this.list_roles_destino = [];
    this.usuarioAplicativoRol = [];
    this.cargarUsuarios();
    $("#all").prop("checked", false);
  }

  agregarUsuario(e: any): void{
    if (e.target.checked) {
      this.listaUsuario.push(e.target.value);
    } else {
      this.listaUsuario = this.listaUsuario.filter(data=>data!=e.target.value)
    }
  }


  guardar(): void{
    let usuario:any
    this.usuarioAplicativoRol=[]
    if (this.listaUsuario.length == 0) {
      this.ventanaEmergenteError(this.informacionIncompleta);
    } else {
      if(this.list_roles_destino.length>1){
        this.ventanaEmergenteError("Debe seleccionar un solo rol para la aplicación");
      }else{
        this.ventanaEmergenteWarning(this.confirmacionAccion)
        .then(resp => {
          if (resp.value) {
            this.listaUsuario.forEach(data => {
              usuario ={
                idAplicativo:'',
                idRole:'',
                idUsuario:''
              }
              usuario.idAplicativo = this.idAplicacion
              usuario.idRole = this.list_roles_destino[0].idRol
              usuario.idUsuario = data
              this.usuarioAplicativoRol.push(usuario)
            });
          }
          console.log("1",this.usuarioAplicativoRol)
          this.usuariosService.guardarAplicativoRolUsuario(this.usuarioAplicativoRol)
          .subscribe(resp => {
          if (resp.data!=null) {
              this.ventanaEmergenteExito();
              this.cancelar();
            } else {
              this.ventanaEmergenteError(this.errorAsignacion);
            }
          });
        });
      }
    }
  }

  ventanaEmergenteExito(): void{
    Swal.fire({
      title: 'Operación exitosa',
      iconHtml: '<img src="assets/img/success.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes',
        title: 'text-success'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#0d6efd'
    });
  }

  ventanaEmergenteError(mensaje: string): void{
    Swal.fire({
      title: 'Operación no exitosa',
      text: `${ mensaje }`,
      iconHtml: '<img src="assets/img/error.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes',
        title: 'text-danger'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#0d6efd'
    });
  }

  ventanaEmergenteWarning(mensaje: string): Promise<SweetAlertResult>{
    let respuesta =
    Swal.fire({
      html: `${ mensaje }` +
            '<h4 class="text-warning fw-bold mt-3">¿Desea continuar?</h4>',
      iconHtml: '<img src="assets/img/warning.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#0d6efd'
    });
    return respuesta;
  }

  cargarAcciones(){
    this.usuariosService.traerAccionesRol()
    .subscribe(resp => {
      this.respuesta = resp;
      this.acciones = this.respuesta.data
    })
  }
}
